module.exports = __webpack_public_path__ + "static/media/ring.db7af8fd.less";